module.exports = __webpack_public_path__ + "static/media/rules_and_consequences_ignoring_4.13f2b62e.png";